import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-tax-payment-declaration',
  templateUrl: './tax-payment-declaration.component.html',
  styleUrls: ['./tax-payment-declaration.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class TaxPaymentDeclarationComponent extends BaseRegulatorySectionComponent implements OnInit {
  public showTaxInformation: boolean;

  @Output() changeCommentText = new EventEmitter<string>();

  ngOnInit(): void {
    this.paymentWithVatChanged(this.regulatoryData?.is_payment_with_vat ?? false);
  }

  paymentWithVatChanged(paymentWithVat: boolean) {
    if (!paymentWithVat) {
      this.regulatoryData.tax_id = null;
      this.regulatoryData.tax_office = null;
    }

    this.showTaxInformation = paymentWithVat;
  }

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.declaration_on_vat_payment_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.declaration_on_vat_payment_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_declaration_on_vat_payment_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_declaration_on_vat_payment_locked = value;
  }
}
